var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDropWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6333_2118)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4718 10.4718C8.21147 10.7321 7.78934 10.7321 7.529 10.4718L3.75776 6.70054C3.49741 6.44022 3.49741 6.01811 3.75776 5.75776C4.01811 5.49741 4.44022 5.49741 4.70057 5.75776L8.0004 9.05761L11.3002 5.75776C11.5606 5.49741 11.9827 5.49741 12.2431 5.75776C12.5034 6.01811 12.5034 6.44022 12.2431 6.70054L8.4718 10.4718Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6333_2118"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDropWhite);
export default __webpack_public_path__ + "static/media/icon-drop-white.1d3e75ea34ea958df7d0443c4c2140c8.svg";
export { ForwardRef as ReactComponent };